import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { PublicSecureLinkStateType } from '@/types/myVaultTypes';

export const openSecureLinkApi = (token: string): Promise<ApiResponseType<PublicSecureLinkStateType>> => {
  return apiService.GET(`/secure-links/${token}/`);
};
